import { Layout } from '../widgets'
import * as routes from '../routes'
import { PaginatedList } from './feed'
import {
  withRouter,
} from '../shared'
import {
  UserLink,
} from './components'
import { Cell } from '../components'

const ItemReportCell = ({report}) => (
  <div className='copyright-audit-element'>
    <Cell>
      <Cell.Body>
        <Cell.Line>
          Reported By:
          <UserLink user_id={report.user_id} username={report.user_id} />
        </Cell.Line>

        <Cell.Line>
          At:
          <div>{report.created_date}</div>
        </Cell.Line>

        <Cell.Line>
          Reviewed:
          <div>{report.reviewed ? 'Yes' : 'No'}</div>
        </Cell.Line>

        <Cell.Line>
          Details:
          <div>{JSON.stringify(report.metadata)}</div>
        </Cell.Line>
      </Cell.Body>
    </Cell>
  </div>
)

const AdminModerationItemReports = (props) => (
  <div className='body-container'>
    <Layout>
    <Layout.Header>Item Report Details</Layout.Header>
    <PaginatedList
      loadUrl={routes.adminModerationReportItemUrl}
      loadParams={{
        item_type: props.router.params.type,
        item_id: props.router.params.id,
      }}
      adminCell={ItemReportCell}
      adminCellItemPropName={'report'}
    />
    </Layout>
  </div>
)

export default withRouter(AdminModerationItemReports)
